import Vue from 'vue'
import Es6Promise from 'es6-promise'
import VConsole from 'vconsole'

import App from './app.vue'
import router from './router'
import { autoRem } from '@space/utils'
import { requireVant } from '@/common/vant-require'

import 'babel-polyfill'

import { getEnv } from '@space/utils'
import { inDev } from '@/common'
const isDev = process.env.NODE_ENV !== 'production'

if (inDev) {
  new VConsole({ maxLogNumber: 1000 })
}

requireVant(Vue)
Es6Promise.polyfill()
Vue.config.productionTip = false
Vue.config.devtools = isDev

new Vue({
  el: '#app',
  router,
  components: { App },
  mounted() {
    autoRem({
      screenMode: 'portrait',
      baseScreenWidth: 375,
    })
  },
  template: '<App/>',
})
